<template>
    <div :class="['plans', editCard ? 'edit-plan' : '']">
        <div class="gray-out-bg"></div>
        <b-card class="transparent-card rate-plan-list">
            <b-card-header :class="simonCarrierAvailable ? '' : 'no-add-new-plan'">
                <div>Plan Templates</div>
                <div class="filters-plan">
                    <strong>Filter: </strong>
                    <span v-if="plansCount.flex || plansCount.tMobile || plansCount.highBandwidth || plansCount.nbiot || plansCount.tMobile" v-on:click="addFilter(0)" :class="[(this.selectedPlans == 0) ? 'active' : '']">All</span>
                    <span v-if="plansCount.simon" :class="[(this.selectedPlans == 1) ? 'active' : '']" @click="addFilter(1)">Simon Plans</span>
                    <span v-if="plansCount.tMobile" :class="[(this.selectedPlans == 2) ? 'active' : '']" @click="addFilter(2)">T-Mobile Plans</span>
                    <span v-if="plansCount.vodafone" :class="[(this.selectedPlans == 6) ? 'active' : '']" v-on:click="addFilter(6)">Vodafone</span>
                    <span v-if="plansCount.kore" :class="[(this.selectedPlans == 9) ? 'active' : '']" v-on:click="addFilter(9)">Kore</span>
                    <span v-if="plansCount.flex" :class="[(this.selectedPlans == 3) ? 'active' : '']" v-on:click="addFilter(3)">Flex</span>
                    <span v-if="plansCount.highBandwidth" :class="[(this.selectedPlans == 4) ? 'active' : '']" v-on:click="addFilter(4)">High Bandwidth</span>
                    <span v-if="plansCount.nbiot && nbIoTAvailable" :class="[(this.selectedPlans == 5) ? 'active' : '']" v-on:click="addFilter(5)">NB IoT</span>
                    <span v-if="plansCount.catm1 && catM1Available" :class="[(this.selectedPlans == 8) ? 'active' : '']" v-on:click="addFilter(8)">Cat M1</span>
                </div>
                <router-link id="plansAddNewPlan" v-if="simonCarrierAvailable" to="/settings/plans/add" tag="button" class="btn btn-success action-element">
                    <i class="fa fa-plus"></i>Add New Plan
                </router-link>
            </b-card-header>
            <b-card-body>
                <div v-if="messageTrue" class="add-succesfully alert alert-success" >Template was add succesfully!</div>

                <div v-if="messageFalse" class="add-false alert alert-warning">Something was wrong! Please contact with support!</div>

                <div class="loading-plans" v-if="loading">
                    <div class="loading-plans-inner">
                        <div class="sk-wave">
                            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                        </div>

                        <div class="text">
                            Plans list is updating...
                        </div>
                    </div>
                </div>
                <div v-if="(templateLists.length > 0 || ratePlanAssigned.length > 0 || vodafoneRatePlans.length > 0|| koreRatePlans.length > 0) && !loading" class="templates-wrap" id="templates-wrap">
                    <div v-if="selectedPlans != 2 && selectedPlans != 6 && selectedPlans != 9" class="simon-plans plans-list">
                        <div v-for="(templateItem, index) in templateLists" :key="templateItem.id" :id="'template-' + templateItem.id"
                             :class="[
                                 'template-item',
                                 templateItem.categoryClass,
                                 (templateItem.active == 1) ? 'plan-active' : 'plan-inactive',
                                 (templateItem.categoryClass != 'flex' && selectedPlans == 3) ? 'plan-hidden' : '',
                                 (templateItem.categoryClass != 'highbandwidth' && selectedPlans == 4) ? 'plan-hidden' : '',
                                 (templateItem.categoryClass != 'nb-iot' && selectedPlans == 5) ? 'plan-hidden' : '',
                                 (templateItem.categoryClass != 'cat-m1' && selectedPlans == 8) ? 'plan-hidden' : ''
                                 ]">
                            <div class="inner-template">
                                <div class="carrier-logo simon">
                                    <img v-if="templateItem.categoryClass == 'flex'" src="../../assets/img/simon-logo-flex.svg" alt="">
                                    <img v-else-if="templateItem.categoryClass == 'nb-iot'" src="../../assets/img/simon-logo-nb-iot.svg" alt="">
                                    <img v-else-if="templateItem.categoryClass == 'cat-m1'" src="../../assets/img/simon-logo-m1.svg" alt="">
                                    <img v-else src="../../assets/img/darklogo.svg" alt="">

                                    <div class="controls">
                                        <a class="plan-deactivate deactivate action-element" v-on:click="confirmdelete(index, templateItem.id, templateItem.name)">Deactivate</a>
                                        <div class="tooltip-on-hover">
                                            <h3>Deactivate Rate Plan</h3>
                                            <p>Selecting This Will Disable This Rate Plan from Future Use</p>
                                            <p>Note: It Wont Affect SIMs Currently on this Plan</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.name }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <span class="name">{{ templateItem.category }}</span>
                                            <span class="value">{{ templateItem.dataLimit }}</span>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">International Roaming</span>
                                                <span class="value" v-if="templateItem.planOptions.hasRoaming == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Voice</span>
                                                <span class="value" v-if="templateItem.planOptions.hasVoice == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <!-- <div class="option">
                                                <span class="name">Data Pooling</span>
                                                <span class="value" v-if="templateItem.planOptions.dataPooling == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div> -->

                                            <div class="option">
                                                <span class="name">SMS</span>
                                                <span class="value" v-if="templateItem.planOptions.sms == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.planOptions.staticIp == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div v-if="hotSpotVisible" class="option">
                                                <span class="name">Hot Spot</span>
                                                <span class="value" v-if="templateItem.planOptions.hotSpot == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Throttle</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleAt && templateItem.dataGuard.throttleAtUnit">{{templateItem.dataGuard.throttleAt}} {{templateItem.dataGuard.throttleAtUnit}}</span>
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleSpeed">{{templateItem.dataGuard.throttleSpeed}}</span>
                                                    <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>

                                            <div class="option">
                                                <span class="name">Cap</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap && templateItem.dataGuard.capAt">{{templateItem.dataGuard.capAt}} {{templateItem.dataGuard.capAtUnit}}</span>
                                                    <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                            <div class="option">
                                                <span class="name">Alert 1</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.fistAlertAtMb">{{templateItem.fistAlertAtMb}}</span>
                                                    <span class="value" v-if="templateItem.fistAlertAtMb">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                            <div class="option">
                                                <span class="name">Alert 2</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.secondAlertAtMb">{{templateItem.secondAlertAtMb}}</span>
                                                    <span class="value" v-if="templateItem.secondAlertAtMb">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="down">
                                            <div class="description">
                                                <span class="name">Plan Description</span>
                                                <span class="value">{{templateItem.description}}</span>
                                            </div>

                                            <div v-if="templateItem.planPrice && templateItem.planPrice.companyDiscount" class="price-plan-wrapper">
                                                <div :class="['start-price', templateItem.planPrice.custom == false && templateItem.planPrice.companyDiscount ? 'discounted' : '']">
                                                    <span>Start Price</span>
                                                    <em>${{templateItem.planPrice.basePrice.toFixed(2)}}</em>
                                                </div>

                                                <div :class="['overage-price', templateItem.planPrice.custom == false && templateItem.planPrice.companyDiscount ? 'discounted' : '']">
                                                    <span>Overage</span>
                                                    <em>${{templateItem.planPrice.ratePerOverageMb.toFixed(3)}}</em>
                                                </div>

                                                <div v-if="templateItem.planPrice.custom == false && templateItem.planPrice.companyDiscount" class="discount">
                                                    <span>Discount</span>
                                                    <em>- {{templateItem.planPrice.companyDiscount*100}}%</em>
                                                </div>

                                                <div v-if="templateItem.planOptions.staticIp == 'ON'" class="static-price">
                                                    <span>Static IP</span>
                                                    <em>${{templateItem.planPrice.staticIpCharge.toFixed(2)}}</em>
                                                </div>

                                                <div v-if="templateItem.planOptions.sms == 'ON'" class="sms-price">
                                                    <span>SMS Price</span>
                                                    <em>${{templateItem.planPrice.smsCharge.toFixed(2)}}</em>
                                                </div>

                                                <div v-if="templateItem.planPrice.custom == false" class="overage-price">
                                                    <span>Overage</span>
                                                    <em>${{templateItem.planPrice.discountedRatePerOverageMb.toFixed(3)}}</em>
                                                </div>

                                                <div class="cost-per-sim">
                                                    <span>Cost per SIM</span>
                                                    <em>${{templateItem.planPrice.discountedBasePrice.toFixed(2)}}</em>
                                                </div>
                                            </div>
                                            <div v-if="templateItem.planPrice && !Boolean(templateItem.planPrice.companyDiscount)" class="price-plan-wrapper">
                                                <div :class="['start-price', templateItem.planPrice.custom == false]">
                                                    <span>Start Price</span>
                                                    <em>${{templateItem.planPrice.basePrice.toFixed(2)}}</em>
                                                </div>

                                                <div :class="['overage-price', templateItem.planPrice.custom == false]">
                                                    <span>Overage</span>
                                                    <em>${{templateItem.planPrice.ratePerOverageMb.toFixed(3)}}</em>
                                                </div>

                                                <div v-if="templateItem.planOptions.staticIp == 'ON'" class="static-price">
                                                    <span>Static IP</span>
                                                    <em>${{templateItem.planPrice.staticIpCharge.toFixed(2)}}</em>
                                                </div>

                                                <div v-if="templateItem.planOptions.sms == 'ON'" class="sms-price">
                                                    <span>SMS Price</span>
                                                    <em>${{templateItem.planPrice.smsCharge.toFixed(2)}}</em>
                                                </div>

                                                <div class="cost-per-sim">
                                                    <span>Cost per SIM</span>
                                                    <em>${{templateItem.planPrice.discountedBasePrice.toFixed(2)}}</em>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedPlans == 2 || selectedPlans == 0" class="tmobile-plans plans-list">
                        <div v-for="(templateItem, index) in ratePlanAssigned" v-bind:key="index" :id="'template-' + templateItem.ratePlanId" :data-ratePlanId="templateItem.ratePlanId" :class="['template-item', 'magenta', (editCard != 0 && editCard == templateItem.ratePlanId) ? 'alert-edit' : '']">

                            <div class="inner-template">
                                <div class="carrier-logo tmobile">
                                    <img src="../../assets/img/magenta-logo.svg" alt="">

                                    <!-- <div v-if="editCard == templateItem.ratePlanId" class="controls">
                                        <i class="fa fa-close" @click="unsavedChanges(templateItem)"></i>
                                    </div>
                                    <div v-else class="controls">
                                        <i class="fa fa-bell"></i>
                                        <a class="edit-alerts" @click="switchPlans(templateItem)">Edit alerts</a>
                                    </div> -->
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.planName }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <div class="name magenta">{{templateItem.planCategory.planCategoryName}}</div>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.staticIp">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="down">
                                        <div class="description">
                                            <span class="name">Plan Description</span>
                                            <span v-if="templateItem.planDescription" class="value">{{templateItem.planDescription}}</span>
                                            <span v-else class="value">--</span>
                                        </div>

                                        <div class="price">
                                            <span class="name">Cost Per Line</span>
                                            <span v-if="templateItem.customUnitPrice" class="value">{{templateItem.customUnitPrice}}</span>
                                            <span v-else class="value">--</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="alert-edition">
                                    <h4>{{ templateItem.planName }}</h4>
                                    <div class="usage-alert-switch">
                                        <div class="usage-alert-switch-box">
                                            <c-switch class="mx-1" color="success" variant="pill" label dataOn="✓"  dataOff="✕" v-model="usageAlertsOn"/>
                                            <span class="value">Data Guard alerts</span>
                                        </div>
                                        <i class="fa fa-info"></i>
                                    </div>
                                    <div class="usage-alert-limit control-group">
                                        <input class="form-control" type="number" min="0" v-model="usageLimit" :disabled="!usageAlertsOn"/>
                                        <select class="custom-select" v-model="usageUnit" :disabled="!usageAlertsOn">
                                            <option value="MB" selected>MB</option>
                                            <option value="GB">GB</option>
                                        </select>
                                    </div>
                                    <h4>Receive Notifications</h4>
                                    <div class="receive-notofications">
                                        <div class="email-notifications">
                                            <FTScheckbox :label="'E-mail'" v-model="emailNotifications" :disable="!usageAlertsOn"></FTScheckbox>
                                        </div>
                                        <div class="sms-notifications">
                                            <FTScheckbox :label="'SMS'" v-model="smsNotifications" :disable="!usageAlertsOn"></FTScheckbox>
                                        </div>
                                    </div>
                                    <p>To use SMS alerts, a phone number needs to be entered for receiving user.</p>
                                    <a @click="goToSettings">Go to user settings</a>
                                    <div class="control-bar">
                                        <button class="btn btn-light" @click="unsavedChanges(templateItem)">Cancel</button>
                                        <button class="btn btn-success" @click="sendAlertUpdate(templateItem.ratePlanId)"
                                        :disabled="(Boolean(templateItem.usageAlert) == false && Boolean(templateItem.usageAlert) == usageAlertsOn) || (Boolean(templateItem.usageAlert) == true && Boolean(templateItem.usageAlert) == usageAlertsOn && usageLimit == templateItem.usageAlert.limit && usageUnit == templateItem.usageAlert.unit && emailNotifications == templateItem.usageAlert.emailNotifications && smsNotifications == templateItem.usageAlert.smsNotifications)"
                                        >Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedPlans == 6 || selectedPlans == 0" class="vodafone-plans plans-list">
                        <div v-for="(templateItem, index) in vodafoneRatePlans" v-bind:key="index" :id="'template-' + templateItem.ratePlanId" :data-ratePlanId="templateItem.ratePlanId" :class="['template-item', 'vodafone', (editCard != 0 && editCard == templateItem.ratePlanId) ? 'alert-edit' : '']">

                            <div class="inner-template">
                                <div class="carrier-logo vodafone">
                                    <img src="../../assets/img/vodafone-logo-white.svg" alt="">
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.planName }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <div class="name">{{ templateItem.planCategory.planCategoryName }}</div>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">Data Limit</span>
                                                <span class="value" v-if="templateItem.dataLimit">{{templateItem.dataLimit.dataLimitName}}</span>
                                                <span class="value" v-else>--</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Provisioning profile</span>
                                                <span class="value no-uppercase" v-if="templateItem.provisioningProfile && templateItem.provisioningProfile.profileName">{{templateItem.provisioningProfile.profileName}}</span>
                                                <span class="value" v-else>--</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">APN</span>
                                                <span class="value no-uppercase" v-if="templateItem.provisioningProfile && templateItem.provisioningProfile.apnType">{{templateItem.provisioningProfile.apnType}}</span>
                                                <span class="value" v-else>--</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">IMEI Match Rule</span>
                                                <span class="value" v-if="templateItem.imeiMatch">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="down">
                                        <div class="description">
                                            <span class="name">Plan Description</span>
                                            <span v-if="templateItem.planDescription" class="value">{{templateItem.planDescription}}</span>
                                            <span v-else class="value">--</span>
                                        </div>
                                    </div>

                                    <div v-if="templateItem.planPrice" class="price-settings">
                                        <div :class="['price-row', templateItem.planPrice.custom == false && templateItem.planPrice.companyDiscount ? 'discounted' : '']">
                                            <span class="name">Base Price</span>
                                            <span class="value">$ {{templateItem.planPrice.basePrice.toFixed(2)}}</span>
                                        </div>
                                        <div :class="['price-row', templateItem.planPrice.custom == false && templateItem.planPrice.companyDiscount ? 'discounted' : '']">
                                            <span class="name">Overage per MB</span>
                                            <span class="value">$ {{templateItem.planPrice.ratePerOverageMb.toFixed(3)}}</span>
                                        </div>
                                        <div v-if="templateItem.planPrice.companyDiscount && templateItem.planPrice.custom == false" class="price-row discount">
                                            <span>Discount</span>
                                            <span class="value">- {{templateItem.planPrice.companyDiscount*100}}%</span>
                                        </div>
                                        <div v-if="templateItem.planPrice.companyDiscount && templateItem.planPrice.custom == false" class="price-row discount-value">
                                            <span>Base Price after discount</span>
                                            <span class="value">$ {{templateItem.planPrice.discountedBasePrice.toFixed(2)}}</span>
                                        </div>
                                        <div v-if="templateItem.planPrice.companyDiscount && templateItem.planPrice.custom == false" class="price-row discount-value">
                                            <span>Overage per MB after discount</span>
                                            <span class="value">$ {{templateItem.planPrice.discountedRatePerOverageMb.toFixed(3)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedPlans == 9 || selectedPlans == 0" class="kore-plans plans-list">
                        <div v-for="(templateItem, index) in koreRatePlans" v-bind:key="index" :id="'template-' + templateItem.ratePlanId" :data-ratePlanId="templateItem.ratePlanId" :class="['template-item', 'vodafone', (editCard != 0 && editCard == templateItem.ratePlanId) ? 'alert-edit' : '']">

                            <div class="inner-template">
                                <div class="carrier-logo kore">
                                    <img src="../../assets/img/kore-plan-logo.svg" alt="">
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2 v-if="templateItem.customName && templateItem.customName != null">{{templateItem.customName}}</h2>
                                            <h2 v-else>{{templateItem.planName}}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <div class="name">{{templateItem.planCategory.planCategoryName}}</div>
                                        </div>

                                        <div class="options">
                                            <div v-if="templateItem.planCategory && templateItem.planCategory.planCategoryId == 14" class="option">
                                                <span class="name">Data Limit</span>
                                                <span class="value">{{templateItem.dataLimit.dataLimitName}}</span>
                                            </div>

                                            <div v-if="templateItem.activationProfile && templateItem.activationProfile.dataPlanName" class="option">
                                                <span class="name">Data Plan</span>
                                                <span class="value">{{templateItem.activationProfile.dataPlanName}}</span>
                                            </div>

                                            <div v-if="templateItem.activationProfile && templateItem.activationProfile.smsPlanName" class="option">
                                                <span class="name">SMS Plan</span>
                                                <span class="value">{{templateItem.activationProfile.smsPlanName}}</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="down">
                                        <div class="description">
                                            <span class="name">Plan Description</span>
                                            <span v-if="templateItem.customDescription" class="value">{{templateItem.customDescription}}</span>
                                            <span v-else-if="templateItem.planDescription" class="value">{{templateItem.planDescription}}</span>
                                            <span v-else class="value">--</span>
                                        </div>
                                    </div>

                                    <div v-if="templateItem.planPrice" class="price-settings">
                                        <div class="price-row">
                                            <span class="name">Base Price</span>
                                            <span class="value">$ {{templateItem.planPrice.basePrice.toFixed(2)}}</span>
                                        </div>
                                        <div :class="['price-row', templateItem.planPrice.custom == false && templateItem.planPrice.companyDiscount ? 'discounted' : '']">
                                            <span class="name">Overage per MB</span>
                                            <span class="value">$ {{templateItem.planPrice.ratePerOverageMb.toFixed(3)}}</span>
                                        </div>
                                        <div class="price-row">
                                            <span class="name">SMS</span>
                                            <span class="value">$ {{templateItem.planPrice.smsCharge.toFixed(2)}}</span>
                                        </div>
                                        <div v-if="templateItem.planPrice.companyDiscount" class="price-row discount">
                                            <span>Discount</span>
                                            <span class="value">- {{templateItem.planPrice.companyDiscount*100}}%</span>
                                        </div>
                                        <div v-if="templateItem.planPrice.companyDiscount" class="price-row discount-value">
                                            <span>Base Price after discount</span>
                                            <span class="value">$ {{templateItem.planPrice.discountedBasePrice.toFixed(2)}}</span>
                                        </div>
                                        <div v-if="templateItem.planPrice.companyDiscount" class="price-row discount-value">
                                            <span>Overage per MB after discount</span>
                                            <span class="value">$ {{templateItem.planPrice.ratePerOverageMb.toFixed(3)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="templateLists.length == 0 && ratePlanAssigned.length == 0 && vodafoneRatePlans.length == 0 && !loading" class="templates-wrap no-templates text-center">
                    <p v-if="simonCarrierAvailable">No SIMON IoT plans have been made. Click here to make a plan.</p>
                    <p v-else>No Plans are available yet</p>
                    <button v-if="simonCarrierAvailable" class="btn btn-success"  v-on:click="goToCreatePlan"><i class="fa fa-plus"></i>Add New Plan</button>
                </div>
            </b-card-body>
        </b-card>

        <b-modal hide-footer hide-header id="delete-template" ref="delete-template" size="md" class="user-settings" centered>
            <div class="user-details">
                <b-row>
                    <b-col md="12" class="deactivate-plan-alert">
                        <img src="../../assets/img/sim-card.png" alt="sim icon"/>
                        <h3>Deactivate Plan</h3>
                        <p>Once a plan is deactivated, it can't be activated again. <br/>
                            Deactivate plan {{ templatename }}?</p>
                    </b-col>
                    <b-col md="12" class="buttons-payment-wrap">
                        <b-button variant="danger" v-on:click="canceldelete">No</b-button>

                        <b-button variant="success action-element" v-on:click="deletetemplate({name}, {description})">Yes</b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal ref="unsaved-magenta" id="unsaved-magenta" :class="['unsaved-magenta']" centered hide-footer>
            <img  src="../../assets/img/unsaved-data.png" alt />

            <h3>Unsaved Data</h3>
            <h4>Plan settings will not be saved, do you wan to continue?</h4>
            <div class="button-wrapper">
                <b-button variant="danger" @click="$refs['unsaved-magenta'].hide()">Cancel</b-button>
                <b-button variant="success" @click="cancelAlertChanges()">Continue</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from "vue";
import globalStore from "../../variables";
import { templateElement } from "@babel/types";
import Axios from "axios";
import { setTimeout } from 'timers';
import VueSession from "vue-session";
import {Switch as cSwitch} from "@coreui/vue";
import FTScheckbox from "../../ftsComponents/FTScheckbox";
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

Vue.use(VueSession);

export default {
    name: "Plans",
    components: {
        FTScheckbox,
        cSwitch
    },
    data() {
        return {
            messageFalse: false,
            messageTrue: false,
            templates: [],
            tempTemplates: [],
            newTemplates: [],
            templateLists: [],
            name: "",
            description: "",
            templatename: "",
            selectedPlans: 0,
            ratePlanAssigned: [],
            vodafoneRatePlans: [],
            koreRatePlans: [],
            editCard: 0,
            usageAlertsOn: false,
            usageLimit: 0,
            usageUnit: 'MB',
            emailNotifications: false,
            smsNotifications: false,
            plansCount: {
                flex: 0,
                highBandwidth: 0,
                nbiot: 0,
                catm1: 0,
                simon: 0,
                tMobile: 0,
                vodafone: 0,
                kore: 0
            },
            loading: true,
            simonCarrierAvailable: true,
            tmobileCarrierAvailable: true,
            vodafoneCarrierAvailable: true,
            koreCarrierAvailable: true,
            simonPlansReady: false,
            tmobilePlansReady: false,
            vodafonePlansReady: false,
            korePlansReady: false,
            nbIoTAvailable: false,
            catM1Available: false,
            hotSpotVisible: false
        };
    },
    mounted: function() {
        if (this.$route.query.message == "false") {
            this.messageFalse = true;
            var cachedThis = this;
            setTimeout(function () {
                cachedThis.messageFalse = false
            }, 3000)
        }

        if (this.$route.query.message == "true") {
            this.messageTrue = true;
            var cachedThis = this;
            setTimeout(function () {
                cachedThis.messageTrue = false
            }, 3000)
        }

        if (this.$cookies.get('nbIoTPlans') == 'true') {
            this.nbIoTAvailable = true
        } else if (this.$session.get('nbIoTPlans') == true) {
            this.nbIoTAvailable = true
        } else {
            this.nbIoTAvailable = false
        }

        if (this.$cookies.get('catM1Plans') == 'true') {
            this.catM1Available = true
        } else if (this.$session.get('catM1Plans') == true) {
            this.catM1Available = true
        } else {
            this.catM1Available = false
        }

        this.getPlans();

        if (this.$cookies.get('hotSpotAccess') == 'true') {
            this.hotSpotVisible = true
        } else if (this.$session.get('hotSpotAccess') == true) {
            this.hotSpotVisible = true
        } else {
            this.hotSpotVisible = false
        }
    },
    methods: {
        showSimonPlans() {
            this.selectedPlans = 1
            document.querySelector(".filters-plan span.active").classList.remove('active');
        },
        showTmobilePlans() {
            this.selectedPlans = 2;
            document.querySelector(".filters-plan span.active").classList.remove('active');
        },
        getTmobileRatePlan() {
            this.loading = true;
            Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=2`)
                .then(response => {
                    this.ratePlanAssigned = response.data.response
                    this.plansCount.tMobile = this.ratePlanAssigned.length;
                    this.tmobilePlansReady = true;
                    if (this.simonPlansReady && this.tmobilePlansReady && this.vodafonePlansReady && this.korePlansReady) {
                        this.loading = false;
                    }
                }).catch(error => {
                    this.tmobilePlansReady = true;
                    if (this.simonPlansReady && this.tmobilePlansReady && this.vodafonePlansReady && this.korePlansReady) {
                        this.loading = false;
                    }
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving Rate Plan Details - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        getKorePlans() {
            this.loading = true;
            Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=4`)
                .then(response => {
                    this.koreRatePlans = response.data.response
                    this.plansCount.kore = this.koreRatePlans.length;
                    this.korePlansReady = true;
                    if (this.simonPlansReady && this.tmobilePlansReady && this.vodafonePlansReady && this.korePlansReady) {
                        this.loading = false;
                    }
                }).catch(error => {
                    this.korePlansReady = true;
                    if (this.simonPlansReady && this.tmobilePlansReady && this.vodafonePlansReady && this.korePlansReady) {
                        this.loading = false;
                    }
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving Rate Plan Details - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        getVodafonePlans() {
            this.loading = true;
            Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=3`)
            .then(response => {
                this.vodafoneRatePlans = response.data.response
                this.plansCount.vodafone = this.vodafoneRatePlans.length;
                this.vodafonePlansReady = true;
                if (this.simonPlansReady && this.tmobilePlansReady && this.vodafonePlansReady && this.korePlansReady) {
                    this.loading = false;
                }
            }).catch(error => {
                this.vodafonePlansReady = true;
                if (this.simonPlansReady && this.tmobilePlansReady && this.vodafonePlansReady && this.korePlansReady) {
                    this.loading = false;
                }
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Retrieving Rate Plan Details - Contact Support',
                    duration: 5000,
                });
                console.log(error)
            })
        },
        getCompanyId() {
            Axios.get(`${globalStore.data.restApiUrl}/account`)
                .then(response => {
                    this.companyId = response.data.companyId;
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Getting company details.',
                        text: "Error Retrieving Company Details - Contact Support",
                        duration: 5000,
                    });
                })
        },
         goToCreatePlan: function (ev) {
            ev.preventDefault();

            window.routeFrom = 'plan';
            this.$router.push("/settings/plans/add");
        },
        getPlans() {
            if (this.simonCarrierAvailable) {
                this.loading = true;
                Axios.get(globalStore.data.restApiUrl + "/account/rate-plans").then(result => {
                    this.templates = result.data.response;
                    this.plansCount.simon = this.templates.length;

                    if (this.templates.length) {
                        this.templates.map(item => {
                            var optionsSms = "OFF";
                            var optionsDataPooling = "OFF";
                            var roaming = "OFF";
                            var tier = null;
                            var staticIp = "OFF";
                            var voice = "OFF";
                            var hotSpot = item.hotSpotPlan ? "ON" : "OFF";

                            if (item.planOptions) {
                                item.planOptions.map(itemOptions => {
                                    if (itemOptions.planOptionName == "SMS") {
                                        optionsSms = "ON";
                                    }

                                    if (itemOptions.planOptionName == "Data Pooling") {
                                        optionsDataPooling = "ON";
                                    }

                                    if (itemOptions.planOptionName == "Tier 1 International Roaming") {
                                        roaming = "ON";
                                        tier = 'Tier 1';
                                    }

                                    if (itemOptions.planOptionName == "Tier 2 International Roaming") {
                                        roaming = "ON";
                                        tier = 'Tier 2';
                                    }

                                    if (itemOptions.planOptionName == "Static IP") {
                                        staticIp = "ON";
                                    }

                                    if (itemOptions.planOptionName == "Voice") {
                                        voice = "ON";
                                    }
                                });
                            }

                            var dataGuard = {
                                hasThrottle: 0,
                                throttleAt: 0,
                                throttleAtUnit: "",
                                throttleSpeed: 0,
                                hasCap: 0,
                                capAt: 0,
                                capAtUnit: ""
                            };

                            if (item.dataGuard && item.dataGuard.hasThrottle == 1) {
                                dataGuard.hasThrottle = 1;
                                if ((item.dataGuard.throttleAt >= 1024 && item.dataGuard.throttleAtUnit == 'mb')) {
                                    dataGuard.throttleAt = (item.dataGuard.throttleAt / 1024).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2});
                                    dataGuard.throttleAtUnit = 'GB';
                                } else if (item.dataGuard.throttleAtUnit == 'gb') {
                                    dataGuard.throttleAt = item.dataGuard.throttleAt.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                                    dataGuard.throttleAtUnit = 'GB';
                                } else if (item.dataGuard.throttleAtUnit == 'mb') {
                                    dataGuard.throttleAt = item.dataGuard.throttleAt
                                    dataGuard.throttleAtUnit = 'MB';
                                }


                                if (item.dataGuard.throttleSpeed && item.dataGuard.throttleSpeed.throttleSpeedId > 0) {
                                    if (item.dataGuard.throttleSpeed.throttleSpeedName.indexOf('mbps') > -1) {
                                        dataGuard.throttleSpeed = item.dataGuard.throttleSpeed.throttleSpeedName.replace('mbps', 'Mbps');
                                    } else {
                                        dataGuard.throttleSpeed = item.dataGuard.throttleSpeed.throttleSpeedName;
                                    }
                                }
                            }

                            if (item.dataGuard && item.dataGuard.hasCap == 1) {
                                dataGuard.hasCap = 1;
                                if (item.dataGuard.capAt == undefined) {
                                    dataGuard.capAt = 'OFF'
                                    dataGuard.capAtUnit = ''
                                } else if ((item.dataGuard.capAt > 1024 && item.dataGuard.capAtUnit == 'mb')) {
                                    dataGuard.capAt = (item.dataGuard.capAt / 1024).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                                    dataGuard.capAtUnit = 'GB';
                                } else if (item.dataGuard.capAtUnit == 'gb') {
                                    dataGuard.capAt = item.dataGuard.capAt.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                                    dataGuard.capAtUnit = 'GB';
                                } else if (item.dataGuard.capAtUnit == 'mb') {
                                    dataGuard.capAt = item.dataGuard.capAt
                                    dataGuard.capAtUnit = 'MB';
                                }
                            }

                            if (dataGuard.hasThrottle == 0) {
                                delete dataGuard.throttleAt
                                delete dataGuard.throttleAtUnit
                                delete dataGuard.throttleSpeed
                            }

                            if (dataGuard.hasCap == 0) {
                                delete dataGuard.capAt
                                delete dataGuard.capAtUnit
                            }

                            let alerts = {
                                alertAt: 0,
                                unit: "mb",
                                additionalNotifications: {
                                    sms: false,
                                    email: false
                                }
                            }

                            var categoryClass = item.planCategory.planCategoryName;

                            if (categoryClass == 'Flex') {
                                this.plansCount.flex++;
                            }

                            if (categoryClass == 'High Bandwidth') {
                                this.plansCount.highBandwidth++;
                            }

                            if (categoryClass == 'NB-IoT') {
                                this.plansCount.nbiot++;
                            }

                            if (categoryClass == 'CAT-M1') {
                                this.plansCount.catm1++;
                            }


                            categoryClass = categoryClass.replace(/\s/g, "").toLowerCase();

                            let firstAlertParsed = false
                            if (item.fistAlertAtMb) {
                                if (item.fistAlertAtMb >= 1024) {
                                    firstAlertParsed = (item.fistAlertAtMb / 1024).toLocaleString('en-US', {maximumFractionDigits: 1}) + ' GB'
                                } else {
                                    firstAlertParsed = item.fistAlertAtMb + ' MB'
                                }
                            }
                            let secondAlertParsed = false
                            if (item.secondAlertAtMb) {
                                if (item.secondAlertAtMb >= 1024) {
                                    secondAlertParsed = (item.secondAlertAtMb / 1024).toLocaleString('en-US', {maximumFractionDigits: 1}) + ' GB'
                                } else {
                                    secondAlertParsed = item.secondAlertAtMb + ' MB'
                                }
                            }


                            var tempTemplateData = {
                                id: item.ratePlanId,
                                name: item.planName,
                                active: item.active,
                                description: item.planDescription,
                                category: item.planCategory.planCategoryName,
                                categoryClass: categoryClass,
                                dataLimit: item.dataLimit.dataLimitName,
                                planOptions: {
                                    dataPooling: optionsDataPooling,
                                    sms: optionsSms,
                                    hasRoaming: roaming,
                                    hasVoice: voice,
                                    hotSpot: hotSpot,
                                    tier: tier,
                                    staticIp: staticIp
                                },
                                dataGuard,
                                usageAlert: item.usageAlert,
                                planPrice: item.planPrice,
                                fistAlertAtMb: firstAlertParsed,
                                secondAlertAtMb: secondAlertParsed
                            };

                            if (item.planPrice && item.planPrice.staticIpCharge && staticIp == 'ON') {
                                item.planPrice.discountedBasePrice += item.planPrice.staticIpCharge
                            }

                            this.templateLists.push(tempTemplateData);
                        });
                    }

                    this.templates = this.templateLists;
                    this.simonPlansReady = true;
                    if (this.simonPlansReady && this.tmobilePlansReady && this.vodafonePlansReady && this.korePlansReady) {
                        this.loading = false;
                    }
                })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting plans error',
                            text: "Something went wrong during getting information from the server. Please contact support.",
                            duration: 5000,
                        });
                        this.simonPlansReady = true;
                        if (this.simonPlansReady && this.tmobilePlansReady && this.vodafonePlansReady && this.korePlansReady) {
                            this.loading = false;
                        }
                        console.log(error);
                    })
            } else {
                this.simonPlansReady = true;
            }

            if (this.tmobileCarrierAvailable) {
                this.getTmobileRatePlan()
            } else {
                this.tmobilePlansReady = true;
            }

            if(this.vodafoneCarrierAvailable) {
                this.getVodafonePlans();
            } else {
                this.vodafonePlansReady = true
            }

            if(this.koreCarrierAvailable) {
                this.getKorePlans();
            } else {
                this.korePlansReady = true
            }
        },
        addFilter(filterId) {
            this.selectedPlans = filterId;
        },
        searchRatePlan: function (ev) {
            var wrapperPlans = document.getElementById("templates-wrap");
            var plansItems = wrapperPlans.getElementsByClassName("template-item");

            for (let i = 0; i < plansItems.length; i++) {
                var titlePlan = plansItems[i].getElementsByTagName("h1")[0];
                var textTitlePlan = titlePlan.textContent || titlePlan.innerText;

                if (textTitlePlan.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1) {
                    plansItems[i].style.display = ''
                } else {
                    plansItems[i].style.display = 'none'
                }
            }
        },
        toggleActive: event => {
            event.preventDefault();
            event.stopPropagation();

            let elem = event.target;
        },
        deletetemplate(name, templateid) {
            this.newTemplates.splice(name.name, 1);

            Axios.patch(globalStore.data.restApiUrl + "/account/rate-plans/" + templateid.description + "/inactive")
                .then(response => {
                    if (response.status == 200) {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Deactivate rate plan',
                            text: "Rate Plan Deactivated Successfully",
                            duration: 5000,
                        });
                        this.templateLists = [];
                        this.getPlans()
                    }
                }).catch(error => {
                    var errorCount = 0;
                    const errorsList = error.response.data.errors;

                    errorsList.forEach(error => {
                        if (error.errorCode == "UNKNOWN") {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Delete template error',
                                text: "Error Deactivating Rate Plan - Contact Support",
                                duration: 5000,
                            });
                            errorCount++;
                        }
                    })

                    if (errorCount == 0) {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Delete template error',
                            text: 'Something was wrong in delete rate plan. Please contact with support.',
                            duration: 5000,
                        });
                    }
                });

            this.$refs["delete-template"].hide();
        },
        confirmdelete(name, templateid, templatename) {
            this.name = name;
            this.description = templateid;
            this.templatename = templatename;

            this.$refs["delete-template"].show();
        },
        canceldelete() {
            this.name = "";
            this.description = "";
            this.templatename = "";

            this.$refs["delete-template"].hide();
        },
        switchPlans(plan) {
            if (this.editCard == 0) {
                this.editCard = plan.ratePlanId;
                if (plan.usageAlert) {
                    this.usageAlertsOn = true;
                    this.usageLimit = plan.usageAlert.limit;
                    this.usageUnit = plan.usageAlert.unit;
                    this.emailNotifications = plan.usageAlert.emailNotifications;
                    this.smsNotifications = plan.usageAlert.smsNotifications;
                } else {
                    this.usageAlertsOn = false;
                }
            } else {
                if (this.editCard == plan.ratePlanId) {
                    this.editCard = 0;
                    this.usageAlertsOn = false;
                    this.usageLimit = 0;
                    this.usageUnit = 'MB';
                    this.emailNotifications = false;
                    this.smsNotifications = false;
                }
            }
        },
        sendAlertUpdate(id) {
            let parsedData;
            if (this.usageAlertsOn) {
                parsedData = {
                    alertAt: this.usageLimit,
                    unit: this.usageUnit,
                    additionalNotifications: {
                        sms: this.smsNotifications,
                        email: this.emailNotifications
                    }
                }
            } else {
                parsedData = {
                    alertAt: 0,
                    unit: 'mb',
                    additionalNotifications: {
                        sms: false,
                        email: false
                    }
                };
            }
            Axios.patch( globalStore.data.restApiUrl + '/rate-plans/associations/client/' + id + '/usage-alert?companyId=' + this.$cookies.get('companyId'), parsedData)
            .then(response => {
                this.editCard = 0;
                this.getTmobileRatePlan();
                this.$notify({
                    type: 'success',
                    group: 'notification',
                    title: 'Alert updated successfully',
                    text: 'Your alerts settings has been saved.',
                    duration: 3000,
                });
            })
        },
        goToSettings() {
            this.$router.push('/settings/users')
        },
        unsavedChanges(plan) {
            if ((Boolean(plan.usageAlert) == false && Boolean(plan.usageAlert) == this.usageAlertsOn) || (Boolean(plan.usageAlert) == true && Boolean(plan.usageAlert) == this.usageAlertsOn && this.usageLimit == plan.usageAlert.limit && this.usageUnit == plan.usageAlert.unit && this.emailNotifications == plan.usageAlert.emailNotifications && this.smsNotifications == plan.usageAlert.smsNotifications)) {
                this.editCard = 0;
                this.usageAlertsOn = false;
                this.usageLimit = 0;
                this.usageUnit = 'MB';
                this.emailNotifications = false;
                this.smsNotifications = false;
            } else {
                this.$refs['unsaved-magenta'].show();
            }
        },
        cancelAlertChanges(){
            this.editCard = 0;
            this.usageAlertsOn = false;
            this.usageLimit = 0;
            this.usageUnit = 'MB';
            this.emailNotifications = false;
            this.smsNotifications = false;
            this.$refs['unsaved-magenta'].hide();
        }
    },
    created() {
        this.simonCarrierAvailable = this.$cookies.get('simonCarrierAvailable') ? this.$cookies.get('simonCarrierAvailable') == 'true' : this.$session.get('simonCarrierAvailable');
        this.tmobileCarrierAvailable = this.$cookies.get('tmobileCarrierAvailable') ? this.$cookies.get('tmobileCarrierAvailable') == 'true' : this.$session.get('tmobileCarrierAvailable');
        if (this.$cookies.get('vodafoneCarrierAvailable') == 'true' || this.$session.get('vodafoneCarrierAvailable')) {
            this.vodafoneCarrierAvailable = true;
        } else {
            this.vodafoneCarrierAvailable = false
        }
        if (this.$cookies.get('koreCarrierAvailable') == 'true' || this.$session.get('koreCarrierAvailable')) {
            this.koreCarrierAvailable = true;
        } else {
            this.koreCarrierAvailable = false
        }
        this.getCompanyId()
    }
};
</script>

<style lang="scss">

    // no magnifying glass
    .fa-search {
        display: none;
    }

    .plans {
        .gray-out-bg {
            display: none;
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: rgba(47, 53, 58, .50);
            z-index: 1;
            pointer-events: none;
        }
        &.edit-plan {
            .gray-out-bg {
                display: block;
            }
        }
    }

.rate-plan-list {
    min-height: calc(100vh - 195px);
    .card-header {
        display: flex;
        justify-content: space-between;
        &.no-add-new-plan {
            justify-content: flex-start;
            .filters-plan {
                margin-left: 120px;
            }
        }
        div {
            line-height: 35px;
        }
        i {
            width: 18px;
            height: 18px;
            -webkit-border-radius: 100%;
            -moz-border-radius: 100%;
            border-radius: 100%;
            border: 2px solid #000000;
            line-height: 13px;
            &::before {
                font-size: 11px;
                line-height: 13px;
            }
        }
    }



    .loading-plans {
        position: absolute;
        top: -20px;
        right: -30px;
        bottom: -25px;
        left: -30px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 4;

        background-color: rgba(47,53,58, 0.7);

        .sk-wave {
            margin: 0 auto !important;
            height: 60px;
            .sk-rect {
                width: 3px;
                background-color: #39c354;
                border-radius: 4px;
            }
        }

        .text {
            text-align: center;
            font-size: 15px;
            font-weight: 700;
        }
    }
}

.templates-wrap {
    >div {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        width: 100%;
    }
}

.filters-plan {
    width: 70%;
    span {
        margin: 0 10px;
        cursor: pointer;
        font-weight: 400;

        &.active {
            font-weight: 700;
            text-decoration: underline;
        }
    }
}

.buttons-payment-wrap {
    display: flex;
    justify-content: flex-end;
    align-content: center;
    align-items: center;

    button {
        padding-left: 20px;
        padding-right: 20px;
        margin: 0 0 0 10px;
    }
}

    .tmobile-plans {
        .template-item {
            .inner-template {
                .plan-content {
                    display: block;
                }
                .alert-edition {
                    display: none;
                }
            }
            &.alert-edit {
                z-index: 10;
                .inner-template {
                    .plan-content {
                        display: none;
                    }
                    .alert-edition {
                        display: block;
                        padding: 10px 12px;
                        .usage-alert-switch {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 10px;

                            .usage-alert-switch-box {
                                display: flex;
                                align-items: center;
                            }

                            i {
                                position: relative;
                                color: #80868D;
                                padding: 2px 6px;
                                border: 1px solid #80868D;
                                -webkit-border-radius: 50%;
                                -moz-border-radius: 50%;
                                border-radius: 50%;
                                cursor: pointer;
                                &:hover {
                                    &::after {
                                        position: absolute;
                                        left: 30px;
                                        top: 0;
                                        content: 'When turned on, you will recive notifications when SIM cards under this plan, will exceed the entered MB Value';
                                        width: 390px;
                                        padding: 8px 16px;
                                        background-color: #241717;
                                        color: #ffffff;
                                        -webkit-border-radius: 5px;
                                        -moz-border-radius: 5px;
                                        border-radius: 5px;
                                        border: 2px solid #5d5d5d;
                                        font-family: "Roboto", sans-serif;
                                        font-size: 14px;
                                        line-height: 17px;
                                    }
                                }
                            }
                        }

                        .usage-alert-limit {
                            display: flex;
                            margin-bottom: 10px;
                            input {
                                flex-grow: 1;
                            }
                            select {
                                width: 70px;
                                margin-left: 10px;
                            }
                        }

                        h4 {
                            font-size: 15px;
                            line-height: 15px;
                            margin-bottom: 10px;
                            font-weight: 700;
                        }

                        .receive-notofications {
                            display: flex;
                            flex-wrap: nowrap;
                            margin-bottom: 16px;
                            .email-notifications,
                            .sms-notifications {
                                width: 50%;
                            }
                        }

                        p {
                            margin-bottom: 16px;
                            font-size: 14px;
                            line-height: 17px;
                        }

                        a {
                            font-size: 14px;
                            line-height: 17px;
                            color: #0088FF;
                            cursor: pointer;
                        }

                        .control-bar {
                            display: flex;
                            justify-content: flex-end;
                            padding: 10px;
                            border-top: none;
                        }

                    }
                }
            }
        }
        .template-item:nth-child(5n) {
            &.alert-edit {
                .inner-template {
                    .alert-edition {
                        .usage-alert-switch {

                            i {
                                &:hover {
                                    &::after {
                                        right: 30px;
                                        left: initial;
                                        z-index: 20;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        @media (max-width: 1780px) {

            .template-item:nth-child(5n) {
                &.alert-edit {
                    .inner-template {
                        .alert-edition {
                            .usage-alert-switch {

                                i {
                                    &:hover {
                                        &::after {
                                            left: 30px;
                                            right: initial;
                                            z-index: 20;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .template-item:nth-child(4n) {
                &.alert-edit {
                    .inner-template {
                        .alert-edition {
                            .usage-alert-switch {

                                i {
                                    &:hover {
                                        &::after {
                                            right: 30px;
                                            left: initial;
                                            z-index: 20;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        @media (max-width: 1305px) {

            .template-item:nth-child(4n) {
                &.alert-edit {
                    .inner-template {
                        .alert-edition {
                            .usage-alert-switch {

                                i {
                                    &:hover {
                                        &::after {
                                            left: 30px;
                                            right: initial;
                                            z-index: 20;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .template-item:nth-child(3n) {
                &.alert-edit {
                    .inner-template {
                        .alert-edition {
                            .usage-alert-switch {

                                i {
                                    &:hover {
                                        &::after {
                                            right: 30px;
                                            left: initial;
                                            z-index: 20;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }





    #unsaved-magenta___BV_modal_content_ {
        .modal-header {
            padding-bottom: 0;
        }

        .modal-body {
            padding: 0 1rem 1rem;
            text-align: center;

            i {
                color: #0088FF;
                margin-bottom: 15px;
            }

            img {
                height: 19px;
                width: auto;
                margin-bottom: 15px;
            }

            h3 {
                display: block;
                margin-bottom: 18px;
                font-size: 15px;
                line-height: 18px;
                font-weight: 700;
                color: #2F353A;
            }

            h4 {
                display: block;
                margin-bottom: 20px;
                font-size: 14px;
                line-height: 24px;
                color: #515B65;
            }

            .button-wrapper {
                button {
                    margin: 0 5px;
                    padding-left: 15px;
                    padding-right: 15px;
                }
            }
        }
    }

    .dark-theme {

        .container-fluid {
            background-color: transparent;

            .rate-plan-list {
                background-color: transparent;
                border-color: #2f353a;

                .card-header {
                    background-color: transparent;
                }

                .card-body {
                    background-color: transparent;
                    border-color: #1a1c1d;

                    .templates-header {
                        .filter {
                            a {
                                color: #EDEEEF;
                            }
                        }
                        .search-template {

                            background-color: #515b65;
                            border-color: #32373d;
                            color: #EDEEEF;

                            .form-control {
                                background-color: transparent;
                                border-color: transparent;
                                color: #EDEEEF;
                                &::placeholder {
                                    color: #EDEEEF;
                                }
                            }

                        }
                    }
                    .templates-wrap {
                        .plans-list {
                            .template-item {
                                border-color: #1d1f20;
                                .inner-template {
                                    .controls {
                                        .tooltip-on-hover {
                                            background-color: #3a4149;
                                            border-color: #1d1f20;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

.no-templates {
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.plans-list {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .plan {
        position: relative;
        width: 308px;
        margin: 0 10px 10px 0;
        padding: 2px 0;

        background-color: #FFFFFF;
        border-radius: 5px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
        overflow: hidden;
        .row {
            margin: 0;
            padding: 12px 20px;
            display: flex;
            justify-content: space-between;
            align-content: center;
            align-items: center;

            &.row-name {
                border-bottom: 1px solid #D5D6D7;
                .name {
                    width: 80%;
                    font-size: 15px;
                    font-weight: 700;
                    line-height: 18px;
                }

                .controls {
                    width: 20%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    align-content: flex-end;

                    .custom-control {
                        padding-left: 0;
                        margin-right: -8px;
                    }
                }
            }

            &.row-plan {
                border-bottom: 1px solid #D5D6D7;

                .name-plan {
                    font-size: 15px;
                    font-weight: 700;
                }

                &.Magenta {
                    .name-plan {
                        color: #FC4DE5;
                    }
                }

                .transfer-plan {
                    font-size: 15px;
                    font-weight: 700;
                }
            }
            &.row-description {
                border-top: 1px solid #D5D6D7;
                color: #3A4149;

                .name {
                    display: block;
                    width: 100%;
                    margin-bottom: 6px;
                    font-size: 14px;
                    font-weight: 700;
                }
            }
            &.row-price {
                border-top: 1px solid #D5D6D7;

                .value {
                    font-size: 20px;
                    line-height: 24px;
                    font-weight: 700;
                    color: #000000;
                }
            }
            &.row-option:nth-child(odd) {
                background-color: #F9F9F9;
            }

            span {
                &.name {
                    font-size: 14px;
                    line-height: 17px;
                    em {
                        margin: 0 10px;
                        font-style: normal;
                    }
                }
                &.value {
                    font-size: 14px;
                    line-height: 17px;
                    color: #515B65;
                    font-weight: 700;
                    text-transform: uppercase;
                    &.on {
                        color: #55CD6C;
                    }
                }
            }
        }

        .edit-data {
            display: none;
            background-color: #fff;
            width: 100%;
            z-index: 2060;
            .header-edit {
                padding: 12px 0;
                border-bottom: 1px solid #D5D6D7;
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }

            .content-edit {
                .row {
                    padding: 0;
                    flex-direction: column;
                    align-items: flex-start;
                    label {
                        display: block;
                        width: 100%;
                        padding: 12px;

                        font-size: 14px;
                        font-weight: 700;
                    }

                    input,
                    textarea {
                        padding: 12px;
                        width: 100%;
                        max-height: 60px;

                        background-color: #F0F3F5;
                        border: 0;
                        font-size: 14px;
                        line-height: 18px;

                        outline: none;
                        resize: none;
                        overflow:hidden;
                    }
                }
            }
            .footer-edit {
                background-color: #fff;
                padding: 8px 0;
                text-align: center;

                button {
                    padding-left: 35px;
                    padding-right: 35px;
                }
            }
        }

        &.edited-plan {
            .showing-data {
                display: none;
            }
            .edit-data {
                display: block;
            }
        }
    }
}

    #delete-template___BV_modal_content_ {
        .user-details {
            .deactivate-plan-alert {
                display: flex;
                flex-direction: column;
                align-items: center;

                img {
                    height: 20px;
                    width: auto;
                    margin-bottom: 15px;
                }

                h3 {
                    font-size: 15px;
                    margin: 0 0 10px;
                }

                p {
                    font-size: 14px;
                    line-height: 24px;
                    text-align: center;
                }
            }

            .buttons-payment-wrap {
                display: flex;
                justify-content: center;
            }
        }
    }
</style>
